export function scrollHeader() {
    gsap.registerPlugin(ScrollTrigger);

    const header = document.querySelector(".site__header");
    const hero = document.querySelector(".site__h1");

    let isHidden = false;
    let isFixed = false;
    let headerHeight = header.offsetHeight;

    // Recalculate on resize (mobile safe)
    window.addEventListener("resize", () => {
    headerHeight = header.offsetHeight;
    if (isFixed) {
        document.body.style.paddingTop = `${headerHeight}px`;
    }
    });

    // 1️⃣ Static → Fixed
    ScrollTrigger.create({
    start: () => hero ? hero.offsetHeight : header.offsetTop,
    end: 99999,

    onEnter() {
        header.classList.add("is-fixed");
        document.body.style.paddingTop = `${headerHeight}px`;
        isFixed = true;
    },

    onLeaveBack() {
        header.classList.remove("is-fixed");
        document.body.style.paddingTop = "";
        gsap.set(header, { yPercent: 0 });
        isFixed = false;
        isHidden = false;
    }
    });

    // 2️⃣ Hide / show when fixed
    ScrollTrigger.create({
    start: () => hero ? hero.offsetHeight : header.offsetTop,
    end: 99999,

    onUpdate(self) {
        if (!isFixed) return;

        if (self.direction === 1 && !isHidden) {
        gsap.to(header, {
            yPercent: -100,
            duration: 0.25,
            ease: "power2.out"
        });
        isHidden = true;
        }

        if (self.direction === -1 && isHidden) {
        gsap.to(header, {
            yPercent: 0,
            duration: 0.25,
            ease: "power2.out"
        });
        isHidden = false;
        }
    }
    });
}